import { DvColumnType, DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { ColDef } from 'ag-grid-community';
import { ReportSettingDto } from '@pages/reports-page/components/report-tabs/report-information-tab/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { DvSplitterEventsService } from '@devinco/ui/dds/splitter';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';

@Injectable()
export class ReportsGridService {
  private toolbarActionsService = inject(ToolbarActionsService);
  private splitterEvents = inject(DvSplitterEventsService);
  private translate = inject(TranslateService);

  readonly colDefs: ColDef<ReportSettingDto>[] = [
    {
      field: 'ReportSettingID',
      headerName: 'ReportsGrid.ReportSettingID',
      type: [ColumnType.Id],
      initialHide: true,
    },
    {
      field: 'ReportDescription',
      headerName: 'ReportsGrid.ReportDescription',
      type: [DvColumnType.Text],
    },
    {
      field: 'ReportType',
      headerName: 'ReportsGrid.ReportType',
      type: [ColumnType.TranslatedText],
    },
    {
      field: 'FilterDescription',
      headerName: 'ReportsGrid.FilterDescription',
      valueFormatter: params => {
        if (params.data?.FilterTranslationKey) {
          return this.translate.instant(params.data.FilterTranslationKey);
        } else {
          return params.value;
        }
      },
      type: [ColumnType.Text],
    },
    {
      field: 'RecurrenceActive',
      headerName: 'ReportsGrid.RecurrenceActive',
      type: [ColumnType.Checkbox],
    },
    {
      field: 'LastSentTime',
      headerName: 'ReportsGrid.LastSentTime',
      type: [ColumnType.DateTime],
    },
    {
      field: 'SendNow',
      headerName: 'ReportsGrid.SendNow',
      type: [ColumnType.Checkbox],
    },
    {
      field: 'FilterTranslationKey',
      type: [ColumnType.Invisible],
      suppressFiltersToolPanel: true,
    },
  ];

  getToolbarActions(
    copyFn: () => void,
    sendNowFn: () => void
  ): DvToolbarAction[] {
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'copy',
        clickFn: copyFn,
        disabled: true,
        tooltipKey: 'Grid.Copy',
      },
      {
        icon: 'delete',
        clickFn: this.toolbarActionsService.deleteSelectedRow,
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'edit',
        clickFn: () => this.splitterEvents.isSplitterOpened$.next(true),
        disabled: true,
        tooltipKey: 'Grid.Edit',
      },
      {
        icon: 'email',
        type: 'raised',
        buttonTextKey: 'Report.Send',
        iconFont: 'material-icons-outlined',
        clickFn: sendNowFn,
        disabled: true,
        tooltipKey: 'Report.SendNow',
      },
    ];
  }
}
